import type {PageRouteConfig} from '@router';

import Login from 'modules/Login/Login';

export function createLoginRoute(): PageRouteConfig {
  return {
    element: <Login />,
    layout: {
      title: '',
      hasNavigate: false,
      hasHeader: false,
      hasBack: false,
      hasLeftIcon: false
    },
    isProtected: false
  };
}
